import axios from 'axios';

// API URL configuration for production-ready deployment
// Use the actual production URL for direct API access
const API_URL = 'https://ai-secretary-app-backend.xxnikkoxx.workers.dev';

// Properly log the configuration
console.log('API client configured with production backend URL:', API_URL);

// Create axios instance with base configuration
export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Important: enables sending cookies with requests
});

// Log the API configuration
console.log('API configured with baseURL:', API_URL);

// Request interceptor for authentication only
api.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('authToken');
    
    // If token exists, add it to the request headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
        // Log the request path and details (for debugging)
    console.log(`Making request to: ${config.baseURL}${config.url}`, {
      method: config.method,
      headers: config.headers,
      data: config.data
    });
    
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // Enhanced error logging for debugging
    console.error('API Error:', {
      url: originalRequest?.url,
      method: originalRequest?.method?.toUpperCase(),
      status: error.response?.status,
      data: error.response?.data,
      requestData: originalRequest?.data
    });
    
    // If error is 401 (Unauthorized) and not already retrying
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      // Clear authentication data
      localStorage.removeItem('authToken');
      
      // Only redirect to login if we're not already there
      const currentPath = window.location.pathname;
      if (currentPath !== '/login' && currentPath !== '/register') {
        console.log('Unauthorized access detected. Redirecting to login...');
        window.location.href = '/login';
      }
    }
    
    return Promise.reject(error);
  }
);
